import React from 'react';
import { Chip } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

export default function CusChip({ option, handleDelete, style }) {
  return (
    <Chip
      label={option.label}
      size="small"
      onDelete={() => handleDelete(option)}
      className="MuiChip-root MuiChip-filled MuiChip-sizeSmall"
      style={{
        height: '24px',
        borderRadius: '8px',
        backgroundColor: '#e0e0e0',
        color: 'rgba(0, 0, 0, 0.87)',
        width: 'fit-content',
        ...style
      }}
      deleteIcon={
        <CancelIcon
          style={{
            width: '18px',
            height: '18px',
            margin: '0 4px 0 -4px',
            color: 'rgba(0, 0, 0, 0.26)'
          }}
        />
      }
    />
  );
}
